import { Modal, DatePicker, Select } from "antd";
const { Option } = Select;

const FilterModal = ({
  isOpen,
  onClose,
  filterDate,
  setFilterDate,
  filterAccessType,
  setFilterAccessType,
  filterMandatory,
  setFilterMandatory, 
}) => {
  return (
    <Modal
      title="Filter Events"
      open={isOpen}
      onCancel={onClose}
      onOk={onClose}
      okText="Apply"
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <DatePicker
          placeholder="Filter by Date"
          onChange={setFilterDate}
          value={filterDate}
          style={{ width: "100%" }}
        />

        <Select
          placeholder="Filter by Access Type"
          onChange={setFilterAccessType}
          allowClear
          style={{ width: "100%" }}
          value={filterAccessType}
        >
          <Option value="Open">Open</Option>
          <Option value="Limited">Limited</Option>
        </Select>

        <Select
          placeholder="Filter by Mandatory Status"
          onChange={setFilterMandatory}
          allowClear
          style={{ width: "100%" }}
          value={filterMandatory}
        >
          <Option value="Yes">Mandatory</Option>
          <Option value="No">Optional</Option>
        </Select>
      </div>
    </Modal>
  );
};

export default FilterModal;
